import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import modalUtils from '../../qti/utils/ModalUtils';
import modalStyles from '../../styles/generic/modal.scss';
import storeManager from '../../store/StoreManager';
import responseActions from '../../actions/ResponseActions';

const OneWayNavigationOfflineModal = (props) => {
    const {
        showModal,
    } = props;

    const returnToQuestion = () => {
        storeManager.dispatch(responseActions.setOneWayNavigationOfflineCommitAttempt(false));
    };

    const selectParent = () => {
        return document.getElementById('app');
    };

    return (<Modal
        ariaHideApp={false}
        isOpen={showModal}
        parentSelector={selectParent}
        role="dialog"
        style={modalUtils.confirmationModalStyles}
        shouldCloseOnOverlayClick
        onRequestClose={returnToQuestion}
        tabindex="0"
        aria={{ describedby: 'ownOfflineModalContent' }}
    >
        <div className={modalStyles.modalContentWrapper} id="ownOfflineModalContent">
            <div className={modalStyles.modalTitle}>
                { t('navigation.oneWay.offlineMode.title') }
            </div>

            <div className={modalStyles.modalContent}>
                <div className={modalStyles.modalContentPart}>
                    <p>
                        { t('navigation.oneWay.offlineMode.descriptionOne') }
                    </p>
                    <p>
                        { t('navigation.oneWay.offlineMode.descriptionTwo') }
                    </p>
                </div>
            </div>

            <div className={modalStyles.modalFooterButtons}>
                <button className={`btn default-btn ${modalStyles.modalMainBtn}`} onClick={returnToQuestion}>
                    { t('navigation.oneWay.offlineMode.returnButton') }
                </button>
            </div>
        </div>
    </Modal>);
};

OneWayNavigationOfflineModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        showModal: !!state.response.isOfflineCommitAttempting,
    };
};

export default connect(mapStateToProps)(OneWayNavigationOfflineModal);
